import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_editor = _resolveComponent("q-editor")!

  return (_openBlock(), _createBlock(_component_q_editor, {
    modelValue: _ctx.showFormModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showFormModal) = $event)),
    "min-height": "5rem",
    "toolbar-rounded": true,
    id: "editor-description",
    toolbar: [
        ['left', 'center', 'right', 'justify'],
        ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
        ['token', 'hr', 'link', 'custom_btn', 'fullscreen'],
        [
            {
                label: _ctx.$q.lang.editor.formatting,
                icon: _ctx.$q.iconSet.editor.formatting,
                list: 'no-icons',
                options: [
                    'p',
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'code'
                ]
            },
            {
                label: _ctx.$q.lang.editor.fontSize,
                icon: _ctx.$q.iconSet.editor.fontSize,
                fixedLabel: true,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                    'size-1',
                    'size-2',
                    'size-3',
                    'size-4',
                    'size-5',
                    'size-6',
                    'size-7'
                ]
            },
            'removeFormat'
        ],
        ['unordered', 'ordered', 'outdent', 'indent'],
    ]
  }, null, 8, ["modelValue", "toolbar"]))
}